import React, { useState } from 'react';
import { useAllUsersQuery, useUpdateUserMutation } from '../../../store/api/user.api';
import { MessageModal } from '../Modal/MessageModal/MessageModal';
import styles from './UsersAdminPage.module.css';
import { useNavigate } from 'react-router-dom';

export const UsersAdminPage = () => {
	const { data: users = [], isLoading, refetch } = useAllUsersQuery();
	const [updateUserData] = useUpdateUserMutation();
	const [roleFilter, setRoleFilter] = useState('all');
	const [adsFromFilter, setAdsFromFilter] = useState('all');
	const [searchId, setSearchId] = useState('');
	const [mesUserId, setMesUserId] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const navigate = useNavigate();

	const handleSendMessage = (userId) => {
		setMesUserId(userId);
	};

	const USERS_PER_PAGE = 20;

	// 👇 собираем уникальные значения adsFrom
	const uniqueAdsFrom = Array.from(new Set(users.map((u) => u.adsFrom).filter(Boolean)));

	const filteredUsers = users.filter((user) => {
		const roleMatches = roleFilter === 'all' || user.role === roleFilter;
		const adsFromMatches = adsFromFilter === 'all' || user.adsFrom === adsFromFilter;
		const idMatches = searchId === '' || user.id.toString().includes(searchId);
		return roleMatches && adsFromMatches && idMatches;
	});

	const totalPages = Math.ceil(filteredUsers.length / USERS_PER_PAGE);

	const handleRoleChange = async (userId, newRole) => {
		try {
			await updateUserData({ id: userId, role: newRole }).unwrap();
			refetch();
		} catch (error) {
			console.error('Ошибка при обновлении роли:', error);
		}
	};

	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= totalPages) {
			setCurrentPage(newPage);
		}
	};

	const usersToShow = filteredUsers.slice(
		(currentPage - 1) * USERS_PER_PAGE,
		currentPage * USERS_PER_PAGE
	);

	if (isLoading) {
		return <div className={styles.loading}>Загрузка...</div>;
	}

	return (
		<div className={styles.main}>
			<button onClick={() => navigate(-1)} className={styles.backButton}>
				← Назад
			</button>
			<h2 className={styles.title}>Пользователи</h2>

			<div className={styles.controls}>
				{/* Фильтр по роли */}
				<div className={styles.filterWrapper}>
					<select
						value={roleFilter}
						onChange={(e) => {
							setRoleFilter(e.target.value);
							setCurrentPage(1);
						}}
						className={styles.filterSelect}
					>
						<option value="all">Все роли</option>
						<option value="ADMIN">ADMIN</option>
						<option value="USER">USER</option>
					</select>
				</div>

				{/* Фильтр по adsFrom (генерируется автоматически) */}
				<div className={styles.filterWrapper}>
					<select
						value={adsFromFilter}
						onChange={(e) => {
							setAdsFromFilter(e.target.value);
							setCurrentPage(1);
						}}
						className={styles.filterSelect}
					>
						<option value="all">Все источники</option>
						{uniqueAdsFrom.map((source) => (
							<option key={source} value={source}>
								{source}
							</option>
						))}
					</select>
				</div>

				{/* Поиск по ID */}
				<div className={styles.searchWrapper}>
					<input
						type="text"
						placeholder="Поиск по ID"
						value={searchId}
						onChange={(e) => {
							setSearchId(e.target.value);
							setCurrentPage(1);
						}}
						className={styles.searchInput}
					/>
				</div>
			</div>

			<div className={styles.header}>
				<div>ID</div>
				<div>Tg ID</div>
				<div>Роль</div>
				<div>Account Password</div>
				<div>Account Email</div>
				<div>Email</div>
				<div>Действия</div>
			</div>

			<div className={styles.list}>
				{usersToShow.map((user) => (
					<div key={user.id} className={styles.row}>
						<div>{user.id}</div>
						<div>{user.tgId}</div>
						<div>
							<select
								value={user.role}
								onChange={(e) => handleRoleChange(user.id, e.target.value)}
								className={styles.roleSelect}
							>
								<option value="ADMIN">ADMIN</option>
								<option value="USER">USER</option>
							</select>
						</div>
						<div>{user.accountPassword}</div>
						<div>{user.accountEmail}</div>
						<div>{user.email}</div>
						<div>
							<button
								className={styles.messageButton}
								onClick={() => handleSendMessage(user.id)}
							>
								Отправить сообщение
							</button>
						</div>
					</div>
				))}
			</div>

			{/* Пагинация */}
			<div className={styles.pagination}>
				<button
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage === 1}
					className={styles.pageButton}
				>
					Назад
				</button>
				<span className={styles.pageInfo}>
					Страница {currentPage} из {totalPages}
				</span>
				<button
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage === totalPages}
					className={styles.pageButton}
				>
					Вперёд
				</button>
			</div>

			<MessageModal 
				userId={mesUserId}
				onClose={() => setMesUserId('')}
				isOpen={!!mesUserId}
			/>
		</div>
	);
};
